export function scrollToDocumentationHeading(headingId: string) {
  if (!headingId) {
    return;
  }

  window.requestAnimationFrame(() => {
    const headingElement = document.getElementById(headingId);
    if (headingElement) {
      headingElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
}
